import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import BeforeAfter from '../components/BeforeAfter';
import ServiceArea from '../components/ServiceArea';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <BeforeAfter />
        <About />
        <ServiceArea />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
